/**
 * Supply only workspaces: goods are delivered, not installed, so there is no deposit.
 * New quotes on them default to no deposit — the full balance is due.
 */
import { directSupabase } from '../../lib/supabaseClient';

export const STANDARD_DEPOSIT_PERCENTAGE = 0.40;

/** Deposit a new quote starts with on this kind of workspace. */
export function defaultDepositTerms(supplyOnly: boolean): {
  hasDeposit: boolean;
  depositPercentage: number;
  depositAmount: number;
} {
  return supplyOnly
    ? { hasDeposit: false, depositPercentage: 0, depositAmount: 0 }
    : { hasDeposit: true, depositPercentage: STANDARD_DEPOSIT_PERCENTAGE, depositAmount: 0 };
}

/** Whether the workspace is Supply only (false if it cannot be read). */
export async function isWorkspaceSupplyOnly(projectId?: string | null): Promise<boolean> {
  const id = String(projectId || '').trim();
  if (!id) return false;
  const { data, error } = await directSupabase
    .from('projects')
    .select('supply_only')
    .eq('id', id)
    .maybeSingle();
  if (error) return false;
  return !!data?.supply_only;
}
